import React from 'react';
import { OverlayDrawerComponentProps } from '@sharefiledev/sharefile-appshell';

const LazyUpdateCustomFieldsDrawer = React.lazy(
	() => import('../components/CreateCustomFieldsDrawer')
);
export const UpdateCustomFieldsDrawer: React.FC<
	OverlayDrawerComponentProps<'urn:sfdrawer:client-mgt-pilet:custom-fields:update'>
> = props => {
	return (
		<React.Suspense fallback={<div data-testid="loading-custom-fields-update-drawer" />}>
			<LazyUpdateCustomFieldsDrawer initialParameters={props} />
		</React.Suspense>
	);
};
